export default {
  globalParams: {},
  acquisitionInfo: {},
  participateInfo: {},
  payInfo: {},
  selectedCard: {},
  extraInfoList: []
}
